var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"bg-white py-4 px-5",attrs:{"rounded":"lg"}},[_c('vue-markdown',{attrs:{"source":_vm.whatsnew}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }